import React, { useState, useMemo } from "react";
import { observer } from "mobx-react-lite";

import "./Buttons.scss";
import Button from "../../../../components/button/Button";
import LoadingSpinner from "../../../../components/loading-spinner/LoadingSpinner";
import { Trash } from "../../../../components/svg/svgImageList";
import useModal from "../../../../components/dialog/useModal";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useThemeService from "../../../../services/theme-service/ThemeService";
import { currentUserService } from "../../../../services/user/CurrentUserStorage";
import { translationService } from "../../../../services/translation/TranslationService";
import { authentication } from "../../../../services/authentication/Authentication";

export const DeleteAccountButton = observer(function () {
  const { themeClass } = useThemeService();
  const [isProcessing, setIsProcessing] = useState(false);
  const { isVisible: isModalVisible, toggleModal } = useModal();

  const [errorKey, setErrorKey] = useState("");
  const [confirmUsername, setConfirmUsername] = useState("");
  const invalidUsername = useMemo(
    () => currentUserService.currentUser.userName !== confirmUsername,
    [confirmUsername]
  );

  const handleConfirmationAction = async () => {
    try {
      setIsProcessing(true);
      await currentUserService.closeUserAccount();
      authentication.logout();
      toggleModal();
    } catch (error: any) {
      setErrorKey(error.errorKey);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <Button
        id="delete-account"
        disabled={isProcessing}
        onClick={() => {
          setConfirmUsername("");
          setErrorKey("");
          toggleModal();
        }}
        icon={{
          svg: Trash,
          textKey: "general.delete.account",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-trash"]),
        }}
      />

      <WarningBeforeAction
        isVisible={isModalVisible}
        titleKey="MyAccount.delete-account.confirmation.title"
        subtitleKey="MyAccount.delete-account.confirmation"
        toggleModal={toggleModal}
        buttonOk={{
          id: "delete-account-ok",
          textKey: "general.delete.account",
          disabled: invalidUsername || isProcessing,
          action: handleConfirmationAction,
        }}
      >
        {isProcessing ? (
          <div className="delete-account-spinner">
            <LoadingSpinner spinnerOnly />
          </div>
        ) : (
          <>
            <p>
              {translationService.translate("MyAccount.delete-account.confirmation.validation")}
            </p>
            <input
              id="delete-account-name"
              placeholder={translationService.translate(
                "MyAccount.delete-account.confirmation.validation-placeholder"
              )}
              value={confirmUsername}
              onChange={(event) => setConfirmUsername(event.target.value)}
              className={themeClass(["input"])}
            />
            <div className="error-message">
              {errorKey && translationService.translate(errorKey)}
            </div>
          </>
        )}
      </WarningBeforeAction>
    </>
  );
});
